export default __webpack_public_path__ + "static/media/emerald-reversed.b8ee2ae3.svg";